import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

const CustomSearch = ({ onSearchChange }) => {
  const { t, i18n } = useTranslation();

  const handleChange = (e) => {
    onSearchChange?.(e.target.value);
  };

  return (
    <TextField
      fullWidth
      size="small"
      placeholder={t("common.search")}
      onChange={handleChange}
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#D0D5DD" }} />
          </InputAdornment>
        ),
      }}
      sx={{
        width: "100%",
        "& .MuiInputBase-root": {
          borderRadius: "8px",
          backgroundColor: "#FEFEFE",
          minHeight: "40px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",
          borderWidth: "1px",
        },
        // Bỏ hiệu ứng hover/focus
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD !important",
          borderWidth: "1px !important",
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD !important",
          borderWidth: "1px !important",
        },
        "& .MuiOutlinedInput-root.Mui-focused": {
          boxShadow: "none",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD !important",
          borderWidth: "1px !important",
        },
        "& .MuiInputBase-input": {
          outline: "none",
          "&:focus, &:focus-visible": {
            outline: "none",
          },
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#000000",
        },
      }}
    />
  );
};

export default CustomSearch;